import {
    BUILDING_CONSTRUCT_REACTIVE,
    BUILDING_UPGRADE_REACTIVE,
} from 'channels/clan/actions'
import { STRONGHOLD_LOAD_SUCCESS } from '../actions/stronghold'
import {
    BUILDING_CONSTRUCTION_SUCCESS,
    BUILDING_CONSTRUCTION_ANIMATED,
} from '../actions/building_construction'
import { BUILDING_UPGRADE_SUCCESS } from '../actions/building_upgrade'
import { SLOT_INFO_SUCCESS } from '../actions/slots'

const initialState = {}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case STRONGHOLD_LOAD_SUCCESS: {
        const { buildings } = action.payload
        return {
            ...buildings,
        }
    }
    case BUILDING_CONSTRUCTION_SUCCESS: {
        const { building } = action.payload
        return {
            ...state,
            [building.id]: {
                ...building,
                modified: true,
            },
        }
    }
    case BUILDING_CONSTRUCTION_ANIMATED: {
        const { buildingId } = action.payload
        return {
            ...state,
            [buildingId]: {
                ...state[buildingId],
                modified: false,
            },
        }
    }
    case SLOT_INFO_SUCCESS: {
        const { building } = action.payload
        return {
            ...state,
            [building.id]: {
                ...state[building.id],
                ...building,
            },
        }
    }
    case BUILDING_UPGRADE_SUCCESS: {
        const { building } = action.payload
        return {
            ...state,
            [building.id]: {
                ...building,
                modified: true,
            },
        }
    }
    case BUILDING_CONSTRUCT_REACTIVE:
    case BUILDING_UPGRADE_REACTIVE: {
        const payloadBuilding = action.payload.building
        const stateBuilding = state[payloadBuilding.id] || {}

        return {
            ...state,
            [payloadBuilding.id]: {
                ...stateBuilding,
                ...payloadBuilding,
                modified: true,
            },
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/buildings.js